import React, { useState } from 'react';
import {
  HiOutlineGlobeAlt,
  HiOutlineSearch,
  HiOutlineBell,
  HiOutlineLogout,
} from 'react-icons/hi';
import { useLocation, useNavigate } from 'react-router-dom'; // Import useLocation from react-router-dom
import { LanguageSwitcher } from '../../assets/svg';

const Navbar = ({ toggleLanguage, language }) => {
  const navigate = useNavigate();
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem('user'));

  let savedData = localStorage.getItem('title');

  // Check if the value is null or empty before parsing
  if (savedData) {
    try {
      savedData = JSON.parse(savedData);
    } catch (error) {
      console.error('Error parsing JSON:', error);
      savedData = null; // Fallback value
    }
  } else {
    savedData = null; // Fallback value if empty or null
  }

  const getPageTitle = () => {
    const path = location.pathname.split('/').filter(Boolean);
    if (path.length === 0) return 'Dashboard';
    return path[path.length - 1]
      .replace(/[-%20]/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  console.log('getPageTitle', getPageTitle());

  const handleAvatarClick = () => {
    setDropdownOpen(!isDropdownOpen);
  };
  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/'); // Navigate to the login page
  };

  return (
    <header className="bg-white border-b px-[35px] py-4 flex items-center justify-between z-30 max-h-[72px] ">
      {/* Left Section: Dynamic Page Title */}
      {savedData !== null ? (
        <h1 className="font-medium text-[24px] text-[#525866]">{savedData}</h1>
      ) : (
        <h1 className="font-medium text-[24px] text-[#525866]">
          {' '}
          {/^[a-f0-9]{24}$/.test(getPageTitle())
            ? 'User Detail'
            : getPageTitle() === 'All   Request'
              ? 'Hospital Requests'
              : getPageTitle() === 'Cluster'
                ? 'Hospital Requests'
                : getPageTitle() === 'Med Specialties'
                  ? 'Medical Specialties'
                  : getPageTitle()}
        </h1>
      )}

      {/* Right Section */}
      <div className="flex items-center space-x-8">
        {/* Search Icon */}
        <button className="text-[#525866]">
          <HiOutlineSearch size={24} />
        </button>
        <button
          onClick={toggleLanguage}
          className="flex items-center space-x-2 text-primary"
        >
          <LanguageSwitcher className="w-[35px] h-[35px]" />
        </button>

        <div className="relative ">
          <button className="text-[#525866] mt-2">
            <HiOutlineBell size={24} />
          </button>
        </div>

        <div className="relative">
          <button
            onClick={handleAvatarClick}
            className="flex items-center space-x-4"
          >
            <img
              src="https://www.w3schools.com/w3images/avatar2.png"
              alt="Avatar"
              className="w-12 h-12 rounded-full"
            />
            <div className="hidden md:flex flex-col text-left">
              <span className="text-sm font-medium">{user?.firstName}</span>
              <span className="text-xs text-gray-500">
                {user?.role === 'physician_management'
                  ? 'Physician'
                  : user?.role === 'hospital_manager'
                    ? 'Hospital Manager'
                    : user?.role === 'cluster_manager'
                      ? 'Cluster Manager'
                      : user?.role === 'moh_manager'
                        ? 'MOH Manager'
                        : user?.role}
              </span>
            </div>
          </button>

          {isDropdownOpen && (
            <div className="absolute right-0 top-10 mt-2 w-48 bg-white shadow-lg rounded-md p-2 space-y-2">
              <div className="flex items-center space-x-2">
                <img
                  src="https://www.w3schools.com/w3images/avatar2.png"
                  alt="Avatar"
                  className="w-8 h-8 rounded-full"
                />
                <div className="text-left">
                  <span className="font-medium">{user?.firstName}</span>
                </div>
              </div>
              <button
                className="w-full text-red-500 flex items-center space-x-2 py-2 px-3 rounded-md hover:bg-gray-100"
                onClick={handleLogout}
              >
                <HiOutlineLogout size={18} />
                <span>Logout</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Navbar;
